import React from "react";

import Alert from "@mui/material/Alert";
import Button from "@mui/material/Button";
import Divider from "@mui/material/Divider";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

import { DateTime } from "luxon";

import { getEarlyTeams, LinkBehavior, weekModes } from "../util/constants";
import Loading from "./Loading";
import StyledPaperCard from "./StyledPaperCard";
import TeamBanner from "./TeamBanner";
import { B } from "./TextStyles";
import TimeLeft from "./TimeLeft";

export default function ThisWeekCard({
  userData,
  week,
  defaultPicks,
  teamsStats,
}) {
  if (!week) {
    return <></>;
  }
  const earlyTeams = getEarlyTeams(teamsStats);
  const isEarlyPick = earlyTeams.includes(userData.currentPick);

  const lockTimeISO = isEarlyPick ? week.earlyLockTime : week.lockTime;
  const lockTime = DateTime.fromISO(lockTimeISO);
  const lockHour = lockTime.hour;
  const lockMinutes = lockTime.minute;
  let lockWeekDay = lockTime.weekdayLong.toUpperCase();
  let lockTimeName;

  if (lockHour === 0 && lockMinutes === 0) {
    lockWeekDay = lockTime.minus({ days: 1 }).weekdayLong.toUpperCase();
    lockTimeName = "MIDNIGHT";
  } else if (lockHour === 12 && lockMinutes === 0) {
    lockTimeName = "NOON";
  }

  return (
    <StyledPaperCard>
      <Stack sx={{ gap: 2 }}>
        <Typography variant="h5">THIS WEEK</Typography>
        <Divider sx={{ marginBottom: 1 }} />
        <Typography component="div">
          {userData.currentPick ? (
            <>
              Your <B>{week ? week.name : "week #"}</B> pick...
            </>
          ) : (
            <>
              No <B>{week ? week.name : "week #"}</B> pick selected...
            </>
          )}
        </Typography>
        {userData.currentPick ? (
          <TeamBanner team={userData.currentPick} />
        ) : (
          <Button
            variant="contained"
            component={LinkBehavior}
            to={`/pick?team=${encodeURIComponent(userData.teamName)}`}
            fullWidth
          >
            <Typography variant="h5">Make Your Pick</Typography>
          </Button>
        )}
        {userData.sbScore ? (
          <Typography component="div">
            Your SB score prediction: <B>{userData.sbScore} pts</B>
          </Typography>
        ) : (
          ""
        )}
        <TimeLeft week={week} userData={userData} isEarlyPick={isEarlyPick} />
        {userData.currentPick ? (
          <Typography component="div">
            {(isEarlyPick && week.mode === weekModes.LOCK_THUR) ||
            week.mode === weekModes.LOCK_ALL ? (
              "This pick is locked."
            ) : (
              <>
                This pick locks on
                <B>
                  {` ${lockWeekDay} at ${
                    lockTimeName ?? lockTime.toFormat("h:mm a")
                  } `}
                </B>
                during game week.
              </>
            )}
          </Typography>
        ) : (
          ""
        )}
        <Divider />
        <Typography component="div">
          {userData.currentRes ? (
            <>
              You <B>{userData.currentRes === "W" ? "Won" : "Lost"}</B>.<br />
              <br />
            </>
          ) : (
            ""
          )}
          <B>Current Available Favorites:</B>
          <br />
          <ol>
            {!defaultPicks ? (
              <Loading />
            ) : defaultPicks === "error" ? (
              <Alert severity="error" sx={{ width: "fit-content" }} />
            ) : (
              defaultPicks.map((team) => (
                <li key={team}>
                  {team} ({teamsStats[team].odds}){" "}
                  {teamsStats[team].loc === "H" ? "vs" : "@"}{" "}
                  {teamsStats[team].opp}
                </li>
              ))
            )}
          </ol>
          {earlyTeams && earlyTeams.length > 0 ? (
            <>
              <B>Early Games Teams:</B> {earlyTeams.join(", ")}
            </>
          ) : (
            ""
          )}
        </Typography>
      </Stack>
    </StyledPaperCard>
  );
}
